import {
  branch,
  compose,
  renderNothing,
  withProps,
  withStateHandlers
} from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { sumBy } from 'lodash'
import { forceHistory } from 'src/composables'
import { getHomeNotifications } from 'src/actions/streamNotifications'
import { selectNotifications } from 'src/store/selectors/streamNotifications'
import { selectRouteKey } from 'src/store/selectors/layout'
import {
  selectStreamToken,
  selectLoanFocus
} from 'src/store/selectors/home/homeowner'
import { scrollToElement } from 'src/helpers/browser'
import { getRef } from 'src/store/elementReference'
import { Targets, MortgagesPanel } from 'src/constants/notificationRefs'
import { openLoans, closeLoans } from 'src/actions/homeowner'
import { hasCustomerToken as isAgent } from 'src/auth'
import { selectHasHomeData } from 'src/store/selectors/home'

const NotificationsContainer = compose(
  forceHistory,
  withProps(() => ({
    isHomeowner: selectRouteKey() === 'home'
  })),
  connect(
    state => ({
      loanFocus: selectLoanFocus(state),
      hasHome: selectHasHomeData(state),
      token: selectStreamToken(state),
      notifications: selectNotifications(state)
    }),
    dispatch => ({
      readNotifications: token => dispatch(getHomeNotifications(token, true)),
      openLoans: () => dispatch(openLoans()),
      closeLoans: () => dispatch(closeLoans())
    })
  ),
  branch(({ hasHome, isHomeowner }) => !isHomeowner || !hasHome, renderNothing),
  withStateHandlers(
    { open: false, markedRead: false },
    {
      setOpen: ({ open, markedRead }, { token, readNotifications }) => (
        forceOpen = !open
      ) => {
        const shouldMarkRead = !open && !markedRead && !isAgent()
        if (shouldMarkRead) {
          readNotifications(token)
        }
        return { open: forceOpen, markedRead: shouldMarkRead || markedRead }
      }
    }
  ),
  injectIntl,
  withProps(({ loanFocus, notifications, openLoans, closeLoans }) => ({
    handleClick: verb => {
      const target = Targets[verb]
      const { current: ref } = getRef(target)
      scrollToElement(ref)

      if (target === MortgagesPanel) {
        openLoans()
        return
      }
      closeLoans()
    },
    unseenNotifications: sumBy(notifications, ({ isSeen }) => (isSeen ? 0 : 1))
  }))
)

export default NotificationsContainer
